import React from 'react';

export const PhoneFill = React.memo(({ fill }) => (
  <path
    d='M8.85573 4.98784L9.70193 4.71756C10.4939 4.46456 11.3409 4.87391 11.6803 5.67376L12.356 7.26716C12.6507 7.96093 12.4872 8.77727 11.9522 9.28484L10.4648 10.6975C10.5565 11.5429 10.8404 12.375 11.3165 13.1937C11.7693 13.9856 12.376 14.6788 13.1009 15.2326L14.8891 14.6355C15.5664 14.41 16.3042 14.67 16.7198 15.2805L17.6878 16.7026C18.1718 17.4129 18.0846 18.3919 17.4851 18.9937L16.8424 19.6388C16.2028 20.2807 15.2898 20.5141 14.4444 20.2501C12.4498 19.6278 10.6157 17.7806 8.94216 14.7085C7.26652 11.6312 6.67515 9.02058 7.16805 6.87666C7.37547 5.97468 8.01818 5.25576 8.85731 4.98784'
    fill={fill}
  />
));
PhoneFill.displayName = 'PhoneFill';
